<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        大连市科技局高大彬局长一行来我司考察
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
      <div class="div-text-left news-Regular-14b6">
        <span>2020-06-17</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
      </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
        <p class="indentation">
          6月17日下午，大连市科技局党组书记高大彬局长、赵宏志副局长、王向阳一级调研员以及大连市高新区科技创新局范学民局长等领导一行莅临我司，对我司工作进行考察指导。
        </p>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news20/1.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
        <p class="indentation">
          我司董事长尹勇教授对科技局领导的到访表示热烈欢迎，并着重向各位领导展示了公司2020年获得大连市重大科技成果转化专项立项的 “高品质航海模拟器及智能化船用产品”项目的进展情况及取得的阶段性成果。
        </p>
        <p class="indentation">
          座谈交流期间，董事长尹勇表示科技创新与科技成果转化是公司现阶段发展建设的核心内容，科技局领导的莅临指导也是对公司工作的认可和支持，未来公司将依托、配合政策需要在科技创新、人才储备等方面持续加大研发投入。 </p>
        <p class="indentation">
          在董事长尹勇、副总经理孙霄峰的陪同下，科技局领导又参观了我司的其他高新技术系列产品，包括智能ECDIS、智能配载仪、虚拟海战模拟器、VR/AR消防及旅游项目、航海模拟器及游艇模拟器等。科技局领导对我司产品给予了高度肯定。
        </p>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news20/2.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news20/3.png" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }
  img {
    vertical-align: middle;
    border-style: none;
    width: 95%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news20.vue